export const COLORS = {
  primary: '#ea580c',
  primaryLight: '#fed7aa',
  slate: '#0f172a',
  slateLight: '#64748b',
  emerald: '#059669',
  emeraldLight: '#a7f3d0',
  violet: '#7c3aed',
  violetLight: '#ddd6fe',
  blue: '#2563eb',
  blueLight: '#bfdbfe',
};

export const TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'performance', label: 'Performance' },
  { id: 'affiliates', label: 'Top Affiliates' },
  { id: 'links', label: 'Recent Links' },
  { id: 'location', label: 'Location Insights' },
];
